/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class SearchController extends Controller {
  queryParams = ['qa_mode'];

  @tracked qa_mode?: string;
}
